export const selectedRadioIndex = (selectedEntity) => (
  Number.isInteger(selectedEntity?.cardIndex) ? selectedEntity.cardIndex : null
);

export const radioItemsBeforeSelectionCompletes = (items, selectedEntity) => {
  const selectedIndex = selectedRadioIndex(selectedEntity);
  if (selectedIndex === null) return items;
  return [];
};

export const markSelectedRadioEntity = (topics = [], { messagePath, groupKey, selectedEntity } = {}) => {
  if (!groupKey || !messagePath) return topics;
  const { topicIndex, messageIndex } = messagePath;
  const topic = topics[topicIndex];
  const message = topic?.messages?.[messageIndex];
  if (!message) return topics;

  const nextTopics = [...topics];
  const nextTopic = { ...topic };
  const messages = [...nextTopic.messages];
  messages[messageIndex] = {
    ...message,
    selectedRadioEntitiesByGroup: {
      ...(message.selectedRadioEntitiesByGroup || {}),
      [groupKey]: selectedEntity,
    },
  };
  nextTopic.messages = messages;
  nextTopics[topicIndex] = nextTopic;
  return nextTopics;
};
